export class BsDatepickerAbstractComponent {
    constructor() {
        this._customRangesFish = [];
    }
    set minDate(value) {
        this._effects.setMinDate(value);
    }
    set maxDate(value) {
        this._effects.setMaxDate(value);
    }
    set daysDisabled(value) {
        this._effects.setDaysDisabled(value);
    }
    set datesDisabled(value) {
        this._effects.setDatesDisabled(value);
    }
    set isDisabled(value) {
        this._effects.setDisabled(value);
    }
    setViewMode(event) { }
    navigateTo(event) { }
    dayHoverHandler(event) { }
    weekHoverHandler(event) { }
    monthHoverHandler(event) { }
    yearHoverHandler(event) { }
    daySelectHandler(day) { }
    monthSelectHandler(event) { }
    yearSelectHandler(event) { }
    /* tslint:disable-next-line: no-any */
    _stopPropagation(event) {
        event.stopPropagation();
    }
}
//# sourceMappingURL=bs-datepicker-container.js.map